__turbopack_context__.v({
  "descriptionText": "_7hiw4q_descriptionText",
  "sectionHeader": "_7hiw4q_sectionHeader",
  "subtitleText": "_7hiw4q_subtitleText",
  "titleText": "_7hiw4q_titleText",
  "top": "_7hiw4q_top",
});
